import { ERR } from 'adv-protocol/src/ErrorCodes'
import { formatNumber, getTextByPropertyId } from '@utils/utils'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'

export function getPickErrorText(errcode: number, defaultText = undefined) {
  let errText = defaultText || ''
  switch (errcode) {
    case ERR.USER_NOT_FOUND:
      errText = '유저 정보를 찾을 수 없습니다. 새로고침을 해주세요.'
      break
    case ERR.BETTOR_BET_NOT_FOUND:
      errText = '베팅 정보를 찾을 수 없습니다. 새로고침을 해주세요.'
      break
    case ERR.PUBLISH_PICK_FAIL_INVALID_BET_HIT_STATE:
      errText = '픽을 공유할 수 없습니다. 픽의 상태를 확인해 주세요.'
      break
    case ERR.PUBLISH_PICK_FAIL_NOT_PERMITTED:
      errText = '픽을 공유할 수 없습니다. 새로고침을 해주세요.'
      break
    case ERR.PUBLISH_PICK_FAIL_ONCE_CREATED:
      errText = '픽이 이미 생성되었습니다. 새로고침을 해주세요.'
      break
    case ERR.PROMISE_NOT_FOUND:
      errText = '픽을 공유할 수 없습니다. 픽의 상태를 확인해 주세요.'
      break
    case ERR.REGISTER_PICK_MARKET_FAIL_TIME_LIMITED:
      errText = '픽 설정 가능한 시간이 지났습니다.'
      break
    case ERR.BUY_PICK_FAIL_PICK_MARKET_NOT_FOUND:
      errText = '픽거래소에서 픽을 찾을 수 없습니다. 새로고침을 해주세요.'
      break
    case ERR.BUY_PICK_FAIL_PICK_YOURS:
      errText = '내가 판매한 픽은 구매할 수 없습니다.'
      break
    case ERR.PICK_NOT_FOUND:
      errText = '픽거래소에서 픽을 찾을 수 없습니다. 새로고침을 해주세요.'
      break

  }
  return errText
}

export function getAuthenticationErrorText(errcode: number, defaultText = undefined) {
  let errText = defaultText || ''

  switch (errcode) {
    case ERR.AUTHENTICATION_FAIL_NOT_ADULT:
      errText = '만 19세 이상부터 이용할 수 있습니다.'
      break
    default:
      errText = '인증 정보에 오류가 있습니다.'
  }
  return errText
}

export function getErrorText(errcode: number, defaultText = undefined) {
  let errText = defaultText || ''
  switch (errcode) {
    case ERR.USER_NOT_FOUND:
      errText = '유저 정보를 찾을 수 없습니다. 새로고침을 해주세요.'
      break
    case ERR.BET_FAIL_FEED_SYSTEM_DELAYED:
      errText = '배당 서버 연결이 원활하지 않습니다.'
      break
    case ERR.BET_FAIL_MEMBER_MULTI_BET_FOLD_OUT_OF_BOUND:
      errText = '최대 10폴드까지 베팅할 수 있습니다.'
      break
    case ERR.BET_FAIL_INSUFFICIENT_SOLUBLE:
      errText = '클럽의 가용 머니 내에서 베팅할 수 있습니다.'
      break
    case ERR.BET_FAIL_PRE_MATCH_STARTED:
      errText = '베팅 마감 시간이 초과되었습니다.'
      break
    case ERR.BET_FAIL_LIVE_ODDS_NOT_STARTED:
      errText = '경기 시작 전에는 라이브 베팅을 할 수 없습니다.'
      break
    case ERR.BET_FAIL_LESSER_BETTING_MIN:
      errText = '{min}~{max}까지 베팅할 수 있습니다.'
      break
    case ERR.BET_FAIL_GREATER_BETTING_MAX:
      errText = '{min}~{max}까지 베팅할 수 있습니다.'
      break
    case ERR.BET_FAIL_INVALID_BET_CALL:
      errText = '베팅 데이터가 잘못되었습니다'
      break
    case ERR.BET_FAIL_MATCH_NOT_FOUND:
      errText = '베팅 실패(매치 정보 획득 실패)'
      break
    case ERR.BET_FAIL_ODDS_NOT_FOUND:
      errText = '베팅 실패(마켓 정보 획득 실패)'
      break
    case ERR.BET_FAIL_ODDS_FILED_NOT_FOUND:
      errText = '베팅 실패(오즈 정보 획득 실패)'
      break
    case ERR.BET_FAIL_UNALLOWED_CALL_TYPE:
      errText = '잘못된 베팅 호출입니다.'
      break
    case ERR.BET_FAIL_INVALID_BET_TYPE_ON:
      errText = '잘못된 베팅 타입입니다.'
      break
    case ERR.BET_FAIL_INVALID_MEMBER_STATE:
      errText = '클럽 멤버 상태를 찾을 수 없습니다. 새로고침을 해주세요.'
      break
    case ERR.BET_FAIL_INSUFFICIENT_MONEY:
      errText = '보유한 {betMoneyTypeText} 부족합니다. 다시 입력해 주세요.'
      break
    case ERR.BET_FAIL_BREAK_CROSS_MULTI_RULE:
      errText = '멀티 베팅이 불가한 타입입니다. 다시 시도해 주세요.'
      break
    case ERR.BET_FAIL_INVALID_ODDSTYPE:
      errText = '잘못된 베팅 타입 입니다.'
      break
    case ERR.BET_FAIL_INVALID_MATCHUP_CATEGORY:
      errText = '잘못된 베팅 카테고리 입니다.'
      break
    case ERR.BET_FAIL_POST_RULE_ODDS:
      errText = '클럽에서 게시 중지한 타입입니다. 새로고침을 해주세요.'
      break
    case ERR.BET_FAIL_SPORT_RULE_NOT_FOUND:
      errText = '클럽에서 종목을 비활성화하였습니다. 새로고침을 해주세요.'
      break
    case ERR.BET_FAIL_CATEGORY_RULE_NOT_FOUND:
      errText = '클럽에서 국가를 비활성화하였습니다. 새로고침을 해주세요.'
      break
    case ERR.BET_FAIL_TOURNAMENT_RULE_NOT_FOUND:
      errText = '클럽에서 리그를 비활성화하였습니다. 새로고침을 해주세요.'
      break
    case ERR.BET_FAIL_SPORT_ODDSTYPE_RULE_NOT_FOUND:
      errText = '클럽에서 비활성화한 타입입니다. 새로고침을 해주세요.'
      break
    case ERR.BET_FAIL_MEMBER_SINGLE_BET_NOT_PERMITED:
    case ERR.BET_FAIL_SINGLE_BET_WITH_ADMIN_CONFIG:
      errText = '싱글 베팅이 허용되지 않은 유저입니다. 클럽 쪽지를 통해 문의하시기 바랍니다.'
      break
    case ERR.BET_FAIL_MEMBER_MULTI_BET_NOT_PERMITED:
      errText = '멀티 베팅이 허용되지 않은 유저입니다. 클럽 쪽지를 통해 문의하시기 바랍니다.'
      break
    case ERR.BET_FAIL_RULE_SINGLE_BET_NOT_SUPPORTED:
      errText = '싱글 베팅을 허용하지 않은 클럽입니다.'
      break
    case ERR.BET_FAIL_RULE_MULTI_BET_NOT_SUPPORTED:
      errText = '멀티 베팅을 허용하지 않은 클럽입니다.'
      break
    case ERR.BET_FAIL_GREATER_HIT_MAX:
      errText = '클럽의 최대 적중금액 내에 알맞게 입력해 주세요.'
      break
    case ERR.BET_FAIL_GREATER_LIMIT_BETTING_RATE:
      errText = '클럽의 최대 배당률 내에 폴드를 선택해 주세요.'
      break
    case ERR.BET_FAIL_GREATER_LIMIT_AXIS_MAX:
      errText = '클럽의 최대 축베팅 적중금액을 초과하였습니다.'
      break
    case ERR.BET_FAIL_GREATER_LIMIT_ODDS_BET_MONEY:
      errText = '클럽에서 설정한 오즈타입 당 최대 베팅 금액을 초과하였습니다.'
      break
    case ERR.BET_FAIL_DAILY_BET_COUNT_LIMITED_IN_CLUB:
      errText = '클럽의 일일 베팅 횟수를 초과하였습니다.'
      break
    case ERR.BET_FAIL_INVALID_DAY_CLUB_SET:
      errText = '클럽에서 설정한 베팅 가능 시간에 베팅해 주세요.'
      break
    case ERR.BET_FAIL_DIFFRENT_RATE:
      errText = '배당이 변경됐습니다. 확인 후 다시 베팅해주십시오.'
      break
    case ERR.BET_FAIL_OUTCOME_EXISTS:
      errText = '이미 마감된 베팅(아잇컴)'
      break
    case ERR.BET_FAIL_INACTIVE_LIVE:
    case ERR.BET_FAIL_INACTIVE_MARKET:
    case ERR.BET_FAIL_INVALID_LIVEODDS:
    case ERR.BET_FAIL_LESS_THEN_MINIMUM_LIVE_MATCH_OUTCOME_RATE:
      errText = '베팅 도중 베팅 상태가 변경되었습니다. 다시 시도해 주세요.'
      break
    case ERR.BET_FAIL_ALREADY_OUTCOME:
      errText = '베팅 마감 시간이 초과되었습니다.'
      break
    case ERR.PRODUCT_INSUFFICIENT_HEART:
      errText = '하트가 부족합니다.'
      break
    case ERR.JOIN_CLUB_ONCE_EXPELLED:
      errText = '추방된 클럽입니다. 클럽 쪽지를 통해 문의하시기 바랍니다.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_CROSS_SINGLE_BET:
      errText = '1폴드 선택이 불가능한 클럽입니다. 2폴드 이상 선택해주세요.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_CROSS_MULTI_BET:
      errText = '클럽 설정으로 1폴드만 베팅할 수 있습니다.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_WDL_SINGLE_BET:
      errText = '1폴드 선택이 불가능한 클럽입니다. 2폴드 이상 선택해주세요.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_WDL_MULTI_BET:
      errText = '클럽 설정으로 1폴드만 베팅할 수 있습니다.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_HANDI_UN_OVER_SINGLE_BET:
      errText = '1폴드 선택이 불가능한 클럽입니다. 2폴드 이상 선택해주세요.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_HANDI_UN_OVER_MULTI_BET:
      errText = '클럽 설정으로 1폴드만 베팅할 수 있습니다.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_SPECIAL_SINGLE_BET:
      errText = '1폴드 선택이 불가능한 클럽입니다. 2폴드 이상 선택해주세요.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_SPECIAL_MULTI_BET:
      errText = '클럽 설정으로 1폴드만 베팅할 수 있습니다.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_LIVE_SINGLE_BET:
      errText = '1폴드 선택이 불가능한 클럽입니다. 2폴드 이상 선택해주세요.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_LIVE_MULTI_BET:
      errText = '클럽 설정으로 1폴드만 베팅할 수 있습니다.'
      break
    case ERR.BET_FAIL_EXIST_PROGRESS_BETTING:
      errText = '이미 진행 중인 베팅이 있습니다. 잠시 후 다시 시도해 주세요.'
      break
    case ERR.BET_TICKET_CHECK_BET_RATE:
      errText = '1.2 미만은 베팅권을 사용할 수 없습니다.'
      break
    case ERR.BET_FAIL_TRY_TOO_FREQUENTLY:
      errText = '0.5초 이내 베팅을 하셨습니다. 베팅 내역 확인 후 다시 시도해주세요.'
      break
    case ERR.CLUB_INVALID_STATE:
      errText = '베팅 상태가 변경되었습니다. 새로고침 후 다시 시도해 주시기 바랍니다.'
      break
    case ERR.BUY_PICK_FAIL_INSUFFICIENT_MONEY:
      errText = '픽 구매를 위한 머니가 부족합니다.'
      break
    case ERR.BUY_PICK_FAIL_INSUFFICIENT_TICKET:
      errText = '픽 구매를 위한 베팅권이 부족합니다.'
      break
    case ERR.ITEM_NOT_FOUND:
      errText = '이미 수령한 아이템 입니다.'
      break
    case ERR.ALREADY_SAVED_BETTING_HISTORY_SHARE:
      errText = '이미 저장한 베팅 내역과 동일합니다.'
      break
    case ERR.ALREADY_RECEIVED_ITEM_MESSAGE:
      errText = '아이템을 수령할 수 없습니다. 새로고침을 해주세요.'
      break
    case ERR.BET_TICKET_NOT_ENOUGH:
      errText = '보유 베팅권이 부족합니다.'
      break
    case ERR.CLUB_MEMBER_NOT_FOUND:
      errText = '클럽 멤버를 찾을 수 없습니다. 새로고침을 해주세요.'
      break
    case ERR.CLUB_NOT_FOUND:
      errText = '클럽 정보를 찾을 수 없습니다. 새로고침을 해주세요.'
      break
    case ERR.BET_CANCEL_FAIL_NOT_EXIST_PROGRESS_BETTING:
      errText = '진행중인 베팅이 없습니다. 새로고침을 해주세요.'
      break
    case ERR.BET_CANCEL_FAIL_ALREADY_START:
      errText = '경기 시작 후에는 베팅을 취소할 수 없습니다.'
      break
    case ERR.BET_CANCEL_FAIL_DISABLE_CANCEL:
      errText = '베팅 취소가 불가능한 클럽입니다.'
      break
    case ERR.BET_CANCEL_FAIL_TIMEOUT:
      errText = '베팅 후 10분까지만 취소가 가능합니다.'
      break
    case ERR.BET_CANCEL_FAIL_NOT_ENOUGH_COMMISION:
      errText = '보유 자산이 부족하여 베팅 취소 수수료를 지불할 수 없습니다.'
      break
    case ERR.TARGET_USER_BLOCKED:
      errText = '이용이 정지된 베터 입니다. 다른 베터를 선택해 주세요.'
      break
    case ERR.TARGET_USER_UNREGISTERED:
      errText = '탈퇴한 베터입니다. 다른 베터를 선택해 주세요.'
      break
    case ERR.LOSS_LIMIT_FAIL_NUMBER_OF_CHANGES_EXCEEDED:
      errText = '손실한도 변경은 주 1회만 가능합니다. 월요일 0시 이후 다시 변경할 수 있습니다.'
      break
    case ERR.BET_FAIL_LOSS_LIMIT_EXCEEDED:
      errText = '1일 손실한도를 초과했습니다.'
      break
    case ERR.FRIEND_INVITATION_NOT_FOUND_NICK:
      errText = '존재하지 않는 닉네임입니다.'
      break
    case ERR.FRIEND_INVITATION_INVALID_CONDITION_NICK:
      errText = '입력할 수 없는 닉네임입니다.'
      break
    case ERR.FRIEND_INVITATION_SELF_CERTIFICATION_NICK:
      errText = '본인 명의 계정의 닉네임은 입력할 수 없습니다.'
      break
    case ERR.PROCESSING_LIVE_BET_EXIST:
      errText = '진행중인 라이브 베팅이 존재합니다.'
      break
    case ERR.BET_FAIL_INSUFFICIENT_EXTRA_ODDS_ITEM:
      errText = '보유한 신의 가호가 부족합니다. 다시 선택해 주세요.'
      break
    case ERR.DAILY_BETTING_EVENT_REWARD_RECEIVE_FAIL_INVALID_CONDITION:
      errText = '참여 조건을 확인해주세요.'
      break
    case ERR.DAILY_BETTING_EVENT_REWARD_RECEIVE_FAIL_COUNT_EXCEED:
      errText = '이미 보상을 수령하였습니다.'
      break
    case ERR.BET_FAIL_UNAVAILABLE_MIX_BET:
      errText = '클럽 설정으로 믹스 베팅을 할 수 없습니다.'
      break
  }
  return errText
}

export function getMixMaxBetError(errTxt: string, min: number, max: number) {
  return errTxt.replace('{min}', formatNumber(min)).replace('{max}', formatNumber(max))
}

export function getErrorTextByBetMoneyType(errTxt: string, betMoneyType: PROPERTY_ID): string {
  const betMoneyText = getTextByPropertyId(betMoneyType) + (betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G ? '이' : '가')
  return errTxt.replace('{betMoneyTypeText}', betMoneyText)
}
